module.exports = __webpack_public_path__ + "images/home-dingtalk-work/shot-2-5d5c31e68a789ac740c3e3dbbf264f56.png";